import {ColumnDef, IdModelTable} from "../../components/ExTable";
import {useTranslation} from "react-i18next";
import {IdListRequest, useOrganizationAdminUserListQuery} from "../../app/api/api";
import React from "react";
import {AdminUser, AdminUserField} from "../../app/api/model/adminUser/adminUser";
import {TFunction} from "i18next";
import {getTranslation, TranslationContext} from "../../utils/getTranslationKey";

const getColumnDefs = (t: TFunction): ColumnDef<AdminUser>[] => [
    {
        fieldName: AdminUserField.ID,
        align: "left",
        label: t("generic_id"),
        sortable: true,
        sticky: true,
    },
    {
        fieldName: AdminUserField.FIRST_NAME,
        align: "left",
        label: t("user_firstName"),
        sortable: true,
    },
    {
        fieldName: AdminUserField.LAST_NAME,
        align: "left",
        label: t("user_lastName"),
        width: 200,
        sortable: false,
    },
    {
        fieldName: AdminUserField.EMAIL,
        align: "left",
        label: t("generic_email"),
        width: 200,
        sortable: false,
    },
    {
        fieldName: AdminUserField.PHONE,
        align: "left",
        label: t("generic_phone"),
        sortable: false,
    },
    {
        fieldName: AdminUserField.MOBILE_PHONE,
        align: "left",
        label: t("generic_mobilePhone"),
        sortable: false,
    },
    {
        fieldName: AdminUserField.LANGUAGE,
        align: "left",
        label: t("generic_language"),
        sortable: false,
        formatCellText: ({cellValue}) =>
            getTranslation({
                context: TranslationContext.LANGUAGE,
                value: cellValue,
                t,
            }),
    },
    {
        fieldName: AdminUserField.TIME_ZONE,
        align: "left",
        label: t("generic_timeZone"),
        sortable: false,
    },
];

export default function AdminUserTable({organizationId}: {organizationId: number}) {
    const {t} = useTranslation();
    return (
        <IdModelTable<AdminUser, IdListRequest>
            queryHook={useOrganizationAdminUserListQuery}
            additionalRequestParams={{id: organizationId}}
            columnDefs={getColumnDefs(t)}
            title={t("organizations_adminUsers")}
            compact={true}
        />
    );
}
